import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private currentUserRoles: string;
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public isAuthenticated$ = this.isAuthenticated.asObservable();
  token = '';
  private isBrowser: boolean;

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.loadToken();
  }

  async loadToken() {
    const token = this.getData()
    if (token?.token) {
      this.token = token?.token;
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  saveUserData(data: any) {
    if (this.isBrowser) {
        sessionStorage.setItem('userData', JSON.stringify(data));
        // sessionStorage.setItem('loggedIn', 'true')
        // sessionStorage.setItem('firstName', data.firstName)
        // sessionStorage.setItem('role', data.role)
        // sessionStorage.setItem('lastName', data.lastName)
    }
  }

  getData() {
    if (this.isBrowser) {
        return JSON.parse(sessionStorage.getItem('userData'));
        // sessionStorage.setItem('loggedIn', 'true')
        // sessionStorage.setItem('firstName', data.firstName)
        // sessionStorage.setItem('role', data.role)
        // sessionStorage.setItem('lastName', data.lastName)
    }
  }

  setLoginAuthentication(data: any, type: any) {
    if (data) {
      // Assuming 'data' is your token
      this.token = data;
      // sessionStorage.setItem('authToken', data); // Save the token in sessionStorage
      this.loadToken(); // Call loadToken to update isAuthenticated
      // sessionStorage.setItem('torusToken', data);
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  hasRole(role: string): boolean {
    if (this.isBrowser) this.currentUserRoles =  sessionStorage.getItem('roles')
    return this.currentUserRoles == role;
  }

  // Method to set roles after login
  setUserRoles(roles: string): void {
    this.currentUserRoles = roles;
    if (this.isBrowser) sessionStorage.setItem('roles', this.currentUserRoles)
  }

  logout(): void {
    this.isAuthenticated.next(false);
    // sessionStorage.removeItem('id_token');
    // sessionStorage.removeItem('torusSkip');
    // sessionStorage.removeItem('OnboardingStep');
    // localStorage.removeItem('id_token');
    // localStorage.removeItem('torusSkip');
    // localStorage.removeItem('OnboardingStep');
    sessionStorage.clear();
    // localStorage.clear();
  }

  setLogin() {
    this.isAuthenticated.next(true);
  }
}
